import { ComponentType } from 'react';

import * as Icons from '@rover/icons';

const DEFAULT_ICON = Icons.AlertInfo;

export const getIconComponent = (
  iconName: string | undefined | null
): ComponentType<React.SVGProps<SVGSVGElement>> => {
  if (!iconName) return DEFAULT_ICON;

  return Icons[iconName] || DEFAULT_ICON;
};
